<template>
  <div class="document-form-container">

    <div class="document-fields-container">

      <div>
        <label class="document-datepicker-label">Дата на изтичане</label>
        <date-picker v-model="startDate"
                     type="date"
                     :format="'DD-MM-YYYY'"
                     :lang="{formatLocale: getFormatLocale()}"
                     class="document-edit-datepicker"
                     placeholder="Изберете дата"/>
        <ErrorInput class="error" v-if="shouldShowError('startDate')" :text="errors['startDate']"/>
      </div>

      <div>
        <label class="document-datepicker-label">Дата на изтичане</label>
        <date-picker v-model="endDate"
                     type="date"
                     :format="'DD-MM-YYYY'"
                     :lang="{formatLocale: getFormatLocale()}"
                     class="document-edit-datepicker"
                     placeholder="Изберете дата"/>
      </div>

      <div v-for="field in documentCopy.fieldDefinitions" :key="field.selector">
        <InputText
            v-if="field.selector !== 'description'"
            class="document-input-field"
            :label="field.name"
            :name="field.selector"
            @value-change="fieldValueChanged"
            :initialValue="getFieldValue(field)"
            :id="field.selector + ''"/>

        <div class="form-description-container" v-if="field.selector === 'description'">
          <p class="document-description-label label">Описание:</p>
          <textarea class="document-description-text-area"
                    v-model="document.fieldValues['description']"
                    :initialValue="getFieldValue(field)">
            </textarea>
        </div>
      </div>

      <Button class="save-button"
              @click.native="saveDocument"
              :color="'green'"
              :text="'Запази'"
              :icon="'fa fa-save'"></Button>

      <Button class="save-button"
              style="margin-top: 60px;"
              v-if="documentId"
              @click.native="showDeleteConfirm = true"
              :color="'red'"
              :text="'Изтрий'"
              :icon="'fa fa-trash-alt'"></Button>

      <div id="confirmDeleteDocument" class="delete-document-confirm" v-if="showDeleteConfirm">
        <p>Сигурне ли сте?</p>
        <Button class="delete-document-button-confirm" @click.native="deleteDocument" :id="'yes'"
                :text="'Да'"></Button>
        <Button class="delete-document-button-confirm" @click.native="showDeleteConfirm = false" :id="'no'"
                :text="'Не'"></Button>
      </div>
    </div>
  </div>
</template>

<script>
import {cloneDeep} from 'lodash';
import InputText from "@/shared/components/form/InputText";
import Button from "@/shared/components/button/Button";
import dateService from "@/services/date.service";
import DatePicker from 'vue2-datepicker';
import carDocumentService from "@/services/carDocument.service";
import router from "../../../routes";
import ErrorInput from "@/shared/components/form/ErrorInput";

export default {
  name: "CarDocumentEditForm",
  components: {ErrorInput, Button, InputText, DatePicker},
  props: {
    document: Object
  },
  created() {
    if (this.documentId && document) {
      this.startDate = new Date(this.documentCopy.documentInfo.startDate);
      this.endDate = new Date(this.documentCopy.documentInfo.endDate);
    }
  },
  data() {
    return {
      documentId: this.$route.params.id,
      showDeleteConfirm: false,
      documentCopy: cloneDeep(this.document),
      startDate: null,
      endDate: null,
      errors: {startDate: null}
    }
  },
  methods: {
    getFieldValue(field) {
      return this.documentCopy.fieldValues[field.selector] ? this.document.fieldValues[field.selector] + '' : '';
    },
    shouldShowError(fieldName) {
      return !!(this.errors && this.errors[fieldName]);
    },
    fieldValueChanged(event) {
      this.documentCopy.fieldValues[event.name] = event.currentValue;
    },
    saveDocument() {
      const tempDocument = {
        id: this.documentId,
        startDate: dateService.formatDateISO(this.startDate ? this.startDate : this.documentCopy.documentInfo.startDate),
        endDate: dateService.formatDateISO(this.endDate ? this.endDate : this.documentCopy.documentInfo.endDate),
        fieldValues: this.documentCopy.fieldValues
      }
      carDocumentService.updateDocument(tempDocument)
          .then(({data}) => this.$emit('updated-document', data))
          .catch((errors) => this.errors = errors.response.data.errors);
    },
    deleteDocument() {
      carDocumentService.deleteDocument(this.documentId)
          .then(() => router.go(-1));
    },
    getFormatLocale() {
      return dateService.getFormatLocale();
    }
  },
  computed: {},
  watch: {
    startDate: {
      handler(newVal) {
        this.errors['startDate'] = null;
        if (newVal) {
          this.document.documentInfo.startDate = dateService.formatDateISO(newVal);
        } else {
          this.document.documentInfo.startDate = null;
        }
      },
      deep: true
    },
    endDate: {
      handler(newVal) {
        this.errors['startDate'] = null;
        if (newVal) {
          this.document.documentInfo.endDate = dateService.formatDateISO(newVal);
        } else {
          this.document.documentInfo.endDate = null;
        }
      },
      deep: true
    }
  }
}
</script>

<style scoped>
.document-form-container {
  width: 750px;
  height: calc(100vh - 140px);
  margin: auto;
}

.document-fields-container {
  width: 80%;
  margin: 0 auto 30px auto;
  display: inline-block;
}

.document-field {
  margin: 20px 0;
}

.save-button {
  width: 300px;
  height: 60px;
  font-size: 26px;
  margin: 45px;
}

.document-add-dropdown {
  width: 80%;
  margin: 20px 0;
}

.delete-document-confirm p {
  text-align: center;
}

.delete-document-button-confirm {
  width: 80px;
  height: 40px;
  float: left;
  margin: 10px;
  font-size: 20px;
}

.delete-document-confirm {
  margin: auto;
  height: 80px;
  width: 200px;
  z-index: 20;
  -webkit-box-shadow: 0 0px 5px 1px var(--shadow-color);
  -moz-box-shadow: 0 0px 5px 1px var(--shadow-color);
  box-shadow: 0 0px 5px 1px var(--shadow-color);
  background-color: #ffffff;
  padding: 15px;
  font-size: 24px;
  color: var(--grey);
}

.document-input-field {
  height: 95px;
  width: 80%;
  margin: 20px 0;
}

.document-edit-datepicker {
  float: left;
  margin: 0 10% 20px 10%;
}

.document-datepicker-label {
  float: left;
  height: 30px;
  width: 100%;
  text-align: left;
  margin-left: 10%;
  margin-top: 20px;
  font-size: 20px;
  color: var(--dark-grey);
}

.error {
  width: 500px;
  margin-top: -7px;
}


.form-description-container {
  display: inline-block;
  width: 80%;
  height: 200px;
  margin: 20px 10%;
}

.document-description-label {
  width: 100%;
}

.document-description-text-area {
  width: 100%;
  height: 100%;
}
</style>
